import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Facilitator.css";
import { FacilitatorForm } from './FacilitatorForm';
import { ViewContainer } from "../../View";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();


const facilitatorRef = React.createRef();

class Facilitator extends Component {

    state = {
        FacilitatorDetails: {
            Person: {
                FirstName: "",
                Surname: "",
                IDNo: ""
            }
        },
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' },
                        
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit},
                        {
                            contextMenu: [
                                { id: "registrationDetails", description: "Registration Details"},
                                { id: "registrationHistory", description: "Registration History"  }
                            ],
                            id: "registration", label: "Registration", width: "120px",  visible: this.props.menuPermissionItem.Edit
                        },
        
                        {
                            contextMenu: [
                                { id: "skillsProgramme", description: "Skills Programme" },
                                { id: "learnership", description: "Learnership" },
                                { id: "qualification", description: "Qualification" },
                                { id: "bursary", description: "Bursary" },
                                { id: "unitstandard", description: "Unit Standard" },
                                { id: "shortcourse", description: "Short Course" },
                            ],
                            id: 'programs', label: 'Programmes', width: "120px",  visible: this.props.menuPermissionItem.Edit
                        },
        
                        { id: 'provider', label: 'Provider', tooltip: '',  visible: this.props.menuPermissionItem.Edit },
                        //{ id: 'idDocument', label: 'ID Document', tooltip: 'Identity Document' },
                        { id: 'crm', label: 'CRM', tooltip: 'Client Relationship Management',  visible: this.props.menuPermissionItem.Edit }
        
                    ]
                }
            ]
        }
    };

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ FacilitatorDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.close();
        } else if ("idDocument" === buttonId) {
            this.props.history.push({
                pathname: '/facilitatorIDDocument',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: `${this.state.FacilitatorDetails.FirstName} ${this.state.FacilitatorDetails.Surname}`,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        }else if ("crm" === buttonId) {
            this.props.history.push({
                pathname: '/facilitatorCRM',
                state: {
                    selection: this.props.location.state.selection,
                    FacilitatorName: `${this.state.FacilitatorDetails.FirstName} ${this.state.FacilitatorDetails.Surname}`,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("provider" === buttonId) {
            this.props.history.push({
                pathname: '/FacilitatorProviderSearch',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: `${this.state.FacilitatorDetails.FirstName} ${this.state.FacilitatorDetails.Surname}`,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        }
    }

    handleToolbarButtonMenuClick(menu) {
        if ("registrationDetails" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorRegistrationDetails',
                state: {
                    selection: this.props.location.state.selection,
                    FacilitatorName: `${this.state.FacilitatorDetails.FirstName} ${this.state.FacilitatorDetails.Surname}`,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("registrationHistory" === menu.id) {
                this.props.history.push({
                    pathname: '/FacilitatorRegistrationHistory',
                    state: {
                        FacilitatorID: this.props.location.state.selection,
                        FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                        FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                    }
                })

        } else if ("skillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorSkillsProgrammeSearch',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("learnership" === menu.id) {
            this.props.history.push({
                pathname: '/Facilitatorlearnerships',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("qualification" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorQualificationSearch',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("unitstandard" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorUnitStandard',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("bursary" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorBursarySearch',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        } else if ("shortcourse" === menu.id) {
            this.props.history.push({
                pathname: '/FacilitatorShortCourseSearch',
                state: {
                    FacilitatorID: this.props.location.state.selection,
                    FacilitatorName: this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname,
                    FacilitatorIDNo: `${this.state.FacilitatorDetails.IDNo}`
                }
            })
        }
    }

    close() {
        this.props.history.push('/facilitatorSearch');
    }

    successCallback = () => {

        this.setState({ message: "Facilitator updated successfully", messageStyle: "SUCCESS" });
    }

    save() {
        let formValue = facilitatorRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/facilitatordetails/UpdateFacilitator", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    render() {
       
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {"Facilitator " + (this.state.FacilitatorDetails.FirstName !== null ? "> " + this.state.FacilitatorDetails.FirstName + " " + this.state.FacilitatorDetails.Surname + (this.state.FacilitatorDetails.IDNo !== null ? " - " + this.state.FacilitatorDetails.IDNo : "") : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="Facilitator" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)} enabled={true} config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "64vh", maxHeight: "64vh" }}>
                                    <FacilitatorForm ref={facilitatorRef} id={this.props.location.state.selection} valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission = {this.props.menuPermissionItem.Edit} />
                                </div>
                            </td> 
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(Facilitator));
